"use strict";

var app = require('app');

module.exports = function (_ref) {
  var el = _ref.el;
  el.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var url = e.currentTarget.href;
    var xhr = new window.XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 2) {
        if (xhr.status === 200) {
          return window.open(url);
        } else {
          app.events.commands.execute('modal:attachments-pending-modal:show');
        }
      }
    };

    xhr.open('GET', url);
    xhr.send();
  });
};